import { ApplicationState } from '../..';

export const commentOrReport = (state: ApplicationState, index: number) => state.details.detailsCommentOrReport.commentsOrReports[index];
export const claimNotificationId = (state: ApplicationState) => state.caseState.selectedCase.claimNotificationId;
